export default {
  CREATED: "created",
  CONFIRMED: "confirmed",
  ACCEPTED: "accepted",
  FUNDS_SENT: "fundsSent",
  DISPUTE: "dispute",
  FINISHED: "finished",
};
